import React from 'react';
import Footer from './Footer';

import '../../style/errorPage.css';
import ConstUtils from '../../config/constants';

const ErrorPage = (props) => {
  const { errorMessage, imgSrc } = props;
  return (
    <div>
      <div className="error-page">
        <img src={imgSrc || `${ConstUtils.StaticS3ImageUrl}/Error.svg`} alt='' />
        <p
          dangerouslySetInnerHTML={{
            __html:
              errorMessage ||
              `The page you are looking for is not available <br/> 
              <div>
                <p className="footer-help-title mb-1">Have a query?</p>
                <p className="footer-help-contact mb-0">
                  Call us at
                  <a href="tel:08068239362" className="footer-help-link">
                      080-68239362
                  </a>
                  , 10am to 6pm
                </p>
              </div>`,
          }}
        />
      </div>
      <Footer isFooterFixed={window.innerHeight >= 750 ? true : false} />
    </div>
  );
};

export default ErrorPage;